import { render, staticRenderFns } from "./ApplianceAttachments.vue?vue&type=template&id=2bc7f5ae"
import script from "./ApplianceAttachments.vue?vue&type=script&lang=js"
export * from "./ApplianceAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports